export const TEXTS = {
  NOTIFY_ME: 'Notify Me',
  NOTIFY: 'Notify Me',
  INVALID_EMAIL: 'Please enter valid email ID',
  SUCCESS_MESSAGE: 'You’ll be notified once the item is back.',
  NO_STOCK_MESSAGE:
    'The size/color selected is currently sold out. You can add this to your wishlist or provide your email address so that we can notify you once it’s available.',
  NOTIFY_SUCCESS: 'Done',
  NOTIFY_ERROR: 'Something went wrong, Please try again',
  HEADING: 'Get notified',
  HELPER_TEXT: 'Enter your email and we’ll let you know when the item is back in stock.',
  HELPER_TEXT_NOTIFY:
    'Provide your email address so that we may notify you once this product is available again',
  EMAIL_LABEL: 'Enter your email',
  BOTTOMSHEET_NOTIFY_TEXT: 'Get notified via email for your size restock',
  NOTIFY_EDIT: 'Edit',
};

export const FORM_STATES = {
  DEFAULT: 'default',
  FOCUS: 'focus',
  ERROR: 'error',
  SUCCESS: 'success',
};
